









































































import { Component, Prop, Watch } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FivGoalSubGroupType, GoalValueType, IFivGoal, IFivGoalGroup } from 'admiral-core';
import { FivApi } from '@/services/FivApi';

@Component({
  name: 'goals-overview-table',
  components: {},
})
class GoalsOverviewTable extends mixins(BaseMixin) {
  @Prop({ type: Object, required: false, default: () => null })
  goalGroup?: IFivGoalGroup;

  @Prop({ type: Array, required: false })
  subGoalGroup?: FivGoalSubGroupType[];

  goals: IFivGoal[] = [];

  get sortedGoals() {
    return this.goals.sort((a, b) => {
      const aText = (a.name || '').toUpperCase();
      const bText = (b.name || '').toUpperCase();
      return aText < bText ? -1 : aText > bText ? 1 : 0;
    });
  }

  @Watch('goalGroup')
  async watchGoalGroup() {
    if (this.goalGroup) {
      const allGoalsResponse = await FivApi.getGoalGroupGoals({
        group: this.goalGroup,
        subGroup: this.subGoalGroup,
        showInactive: true,
      });

      this.goals = allGoalsResponse.data;
    }
  }

  goalType(goal: IFivGoal) {
    return goal.valueType === GoalValueType.Valuation ? 'Bewertung' : 'Stückzahl';
  }

  setInactive(goal: IFivGoal) {
    try {
      goal.isActive = false;
      FivApi.updateGoal(goal.id, {
        isActive: false,
      });
    } catch (e) {
      console.log(e);
    }
  }

  setActive(goal: IFivGoal) {
    try {
      goal.isActive = true;

      FivApi.updateGoal(goal.id, {
        isActive: true,
      });
    } catch (e) {
      console.log(e);
    }
  }
}

export default GoalsOverviewTable;
